import React, { useEffect, useRef } from "react";
import { NumberInput, TextInput, minValue, required } from "react-admin";
import { Grid } from "@mui/material";
import { useFormContext, useWatch } from "react-hook-form";
import { PERSONAL_CAR_TRANSPORT_TYPES, TransportTypes } from "utils/constants";

const CAR_FIELDS = ["vehicleTypeAndMake", "averageFuelConsumption", "fuelType", "fuelPrice", "distanceInKm"];

const PersonalCarFields = () => {
  const { setValue } = useFormContext();
  const transportType = useWatch({ name: "transportType" });
  const isPersonalCar = PERSONAL_CAR_TRANSPORT_TYPES.includes(transportType);
  // The backend only enforces these for a conventional personal car, not the electric one.
  const isRequired = transportType === TransportTypes.PersonalCar;
  const isFirstRender = useRef(true);

  // Keep stale values out of the payload once the transport no longer needs them.
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    if (!isPersonalCar) CAR_FIELDS.forEach(field => setValue(field, null));
  }, [isPersonalCar, setValue]);

  if (!isPersonalCar) return null;

  const positive = minValue(0.01, "Стойността трябва да е по-голяма от 0!");
  const validateAmount = isRequired ? [required(), positive] : [positive];
  const validateText = isRequired ? required() : undefined;

  return (
    <Grid container>
      <Grid
        item
        xs={12}
        md={4}
        lg={3}
        p={0.5}
      >
        <TextInput
          label="Вид и марка на МПС"
          source="vehicleTypeAndMake"
          validate={validateText}
        />
      </Grid>
      <Grid
        item
        xs={6}
        md={4}
        lg={2}
        p={0.5}
      >
        <TextInput
          label="Вид гориво"
          source="fuelType"
          validate={validateText}
        />
      </Grid>
      <Grid
        item
        xs={6}
        md={4}
        lg={2}
        p={0.5}
      >
        <NumberInput
          label="Среден разход на гориво"
          source="averageFuelConsumption"
          min={0}
          validate={validateAmount}
        />
      </Grid>
      <Grid
        item
        xs={6}
        md={4}
        lg={2}
        p={0.5}
      >
        <NumberInput
          label="Цена на горивото"
          source="fuelPrice"
          min={0}
          validate={validateAmount}
        />
      </Grid>
      <Grid
        item
        xs={6}
        md={4}
        lg={2}
        p={0.5}
      >
        <NumberInput
          label="Разстояние (км)"
          source="distanceInKm"
          min={0}
          validate={validateAmount}
        />
      </Grid>
    </Grid>
  );
};

export default PersonalCarFields;
